module.exports = __webpack_public_path__ + "static/media/onscreen_credits_1080_tl.682f70c3.png";